export const SHARED_LAYOUT_NAMESPACE = "shared-layout";
export const TOP_BAR_TK = "TOP_BAR_TK";
export const ACCOUNT_MENU_TK = "ACCOUNT_MENU_TK";
